import { UseFormGetValues, UseFormSetValue } from "react-hook-form";
import { ShipmentType } from "@api/graphql/generated/generated-types";
import { StopOrderControls, useStopOrderControls } from "./useStopOrderControls";
import { isMultiDropOffType } from "../utils/stopOrderRowRules";
import {
  CustomRecurrenceScheduleType,
  ExtendedRecurrenceScheduleType,
} from "@src/orders/create/utils/CreateOrderContextProvider";
import { CreateOrderFormData } from "@src/orders/create/types";

type StopOrderControlsInput = Parameters<typeof useStopOrderControls>[0];

interface UseCreateStopOrderProps
  extends Pick<StopOrderControlsInput, "watchStops" | "swap" | "insert"> {
  shipmentType: ShipmentType | undefined;
  recurrenceSchedule: ExtendedRecurrenceScheduleType;
  setValue: UseFormSetValue<CreateOrderFormData>;
  getValues: UseFormGetValues<CreateOrderFormData>;
}

// A new order has no completed stops.
const NO_COMPLETED_STOP_IDS = new Set<string>();

/** Move up / Move down / Insert stop below for the New Order form's stops. */
export function useCreateStopOrder({
  shipmentType,
  recurrenceSchedule,
  watchStops,
  swap,
  insert,
  setValue,
  getValues,
}: UseCreateStopOrderProps): StopOrderControls {
  return useStopOrderControls<CreateOrderFormData>({
    isEnabled:
      isMultiDropOffType(shipmentType) &&
      recurrenceSchedule === CustomRecurrenceScheduleType.DoesNotRepeat,
    watchStops,
    completedStopIds: NO_COMPLETED_STOP_IDS,
    swap,
    insert,
    setValue,
    getValues,
    fieldArrayName: "shipments.0.stops",
  });
}
